module.exports = __webpack_public_path__ + "img/art6.dc312321.png";